import React, { useMemo } from 'react';
import { Modal } from 'antd';
import { CopyableDataSection } from '@ydistri/ds';
import type { MultiselectCustomerPartialEntity } from './configurationMultiselectTypes';
import { buildMultiselectSelectedSectionData } from './configurationMultiselectModalLib';

interface MultiselectSelectedDataModalProps {
  open: boolean;
  selectedIds: number[];
  data: MultiselectCustomerPartialEntity[];
  compareAsInt?: boolean;
  onClose: () => void;
}

const MultiselectSelectedDataModal: React.FC<MultiselectSelectedDataModalProps> = ({
  open,
  selectedIds,
  data,
  compareAsInt = false,
  onClose,
}) => {
  const selectedData = useMemo(
    () =>
      buildMultiselectSelectedSectionData({
        selectedIds,
        data,
        compareAsInt,
      }),
    [compareAsInt, data, selectedIds],
  );

  return (
    <Modal open={open} title="Selected data" onCancel={onClose} footer={null} width={500}>
      <CopyableDataSection
        title="Selected IDs"
        data={selectedData.data}
        dataToDisplay={selectedData.dataToDisplay}
        emptyText="Nothing is selected"
        variant="neutral"
        maxHeight="20rem"
      />
    </Modal>
  );
};

export default MultiselectSelectedDataModal;
